export const ActionTypes = {
  GET_MEETING_BY_ID: "GET_MEETING_BY_ID",
  GET_MEETING_LIST: "GET_MEETING_LIST",
  GET_CONVOCATION_BY_ID: "GET_CONVOCATION_BY_ID",
  SET_MEETING_FILTER_TYPE: "SET_MEETING_FILTER_TYPE",
  GET_MEETING_LIST_BY_TYPE: "GET_MEETING_LIST_BY_TYPE",
  GET_MEETING_LIST_BY_FILTER: "GET_MEETING_LIST_BY_FILTER",
  GET_UPCOMMING_MEETING_LIST: "GET_UPCOMMING_MEETING_LIST",
  GET_DEFAULT_MEETING_LIST: "GET_DEFAULT_MEETING_LIST",
  GET_CUSTOM_MEETING_LIST: "GET_CUSTOM_MEETING_LIST",
  GET_MEETING_VOTER_SUMMARY: "GET_MEETING_VOTER_SUMMARY",
  GET_MEETING_COMMENT_LIST: "GET_MEETING_COMMENT_LIST",
  GET_MEETING_MOM_LOG: "GET_MEETING_MOM_LOG",
  SET_DELETED_USER: "SET_DELETED_USER",
  ADD_DELETED_USER: "ADD_DELETED_USER",
  DELETE_DELETED_USER: "DELETE_DELETED_USER",
  RESET_STATE: 'RESET_STATE'
};
